import styled, { css } from 'styled-components';
import { colors } from '../../../assets/variables';

const Wrap = styled.div`
  margin-bottom: 0px;
  @media screen and (max-width: 415px) {
    ${props => {
    if (!props.homepage) {
      return css`
          margin-bottom: 18px;
        `;
    }
  }}
  }
  ${props => {
    if (!props.homepage) {
      return css`
        margin-bottom: 32px;
      `;
    }
  }}
   ${props => {
    if (props.homepage) {
      return css`
         margin-bottom: 0px;
       `;
    }
  }}
  
  ${props => {
    if (props.isDesktop) {
      return desktopStyles;
    }
  }}

  .button-full-white {
    background-color: white;
    color: #174489;
    &:hover,
    &:focus,
    &:active {
      background-color: #25b3eb;
    }
  }
  .button-outline-white {
    background-color: transparent;
    box-shadow: inset 0 0 0 2px white;
    color: white;
    margin-left: 16px;
    &:hover,
    &:focus,
    &:active {
      background-color: #25b3eb;
      box-shadow: inset 0 0 0 2px #25b3eb;
      color: #174489;
    }
  }
`;
const FixedPos = styled.div`
  width: 100%;
  top: 0;
  z-index: 9;
`;
const TopMenu = styled.div`
  min-height: 80px;
  /* padding: 16px 0 0 0; */
  display: flex;
  justify-content: space-between;
  // justify-content: flex-start;
`;
const Text = styled.span`
  font-weight: bold;
  margin-top: 6px;
  line-height: 1.2;
  margin-right: 4px;
`;
const Nav = styled.div`
  display: flex;
  margin-left: auto;
`;

const Menu = styled.div`
  display: flex;
  margin-left: 0;

  & > a {
    text-decoration: none;
    color: ${colors.primary};

    &:hover {
      text-decoration: none;
      color: #174489;
    }
    &:focus {
      background-color: transparent;
    }
  }
  & > button {
    text-decoration: none;
    color: ${colors.primary};
    padding-left: 16px;
    &:hover {
      text-decoration: none;
      color: #174489;
    }
  }
`;

const Logo = styled.div`
  max-height: 70px;
  max-width: 450px;
  margin-right: auto;
  display: flex;
  align-items: center;
  a {
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 375px) {
    img {
      max-height: 50px;
    }
  }
`;
const ButtonLink = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  font-family: arial, sans-serif;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
`;
const BambuserWrap = styled.div`
  position: fixed;
  right: 3%;
  top: 65%;
  z-index: 99;
`;
const ButtonBambuser = styled.p`
  color: #0b2641;
  cursor: pointer;
  font-weight: 700;
  margin-bottom: 0px;
  &:hover {
    text-decoration: underline;
  }
`;

const TextWrap = styled.div`
  border-radius: 10px;
  padding: 16px 24px;
  background: white;
  box-shadow: 2px 2px 8px black;
  position: relative;
  display: none;
`;
const ChatButton = styled.div`
  background-image: url('https://cdn.getwaterfit.co.uk/static/files/images/bambuser.png');
  box-shadow: 2px 2px 8px black;
  width: 60px;
  transition: all 200ms;
  height: 60px;
  border-radius: 50%;
  position: relative;
  right: 5%;
  top: 75%;
  transition-duration: 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  background-size: contain;

  button {
    background-color: transparent;
    border: 0;
    width: 60px;
    min-width: 60px;
    transition: all 200ms;
    border: 2px solid ${colors.primary};
    flex: 1;
    height: 60px;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      border: 2px solid ${colors.action};
    }
  }
`;

const StyledBurger = styled.div`
  top: 45%;
  right: 2rem;
  display: flex;
  position: absolute;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  transition: all 300ms ease-in-out;
  &:focus {
    outline: none;
  }
  div {
    width: 2rem;
    height: 0.25rem;
    background: #0d0c1d;
    border-radius: 10px;
    transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    transform-origin: 1px;
  }
  &.active {
    & > div {
      &:nth-child(2) {
        opacity: 0;
      }
      &:nth-child(1) {
        transform: translateY(0) rotate(45deg);
      }
      &:nth-child(3) {
        transform: translateY(0) rotate(-45deg);
      }
    }
  }
`;
const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  font-size: 28px;
  background: #fff;
  transform: translateX(100%);
  height: 100vh;
  text-align: left;
  padding-top: 32px;
  padding-left: 16px;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 83px;
  transition: all 0.3s ease-in-out;
  width: 100%;

  & > a {
    text-decoration: none;
    color: ${colors.primary};
    padding: 0 16px 16px 0;
    transition: all 0.3s linear;
    &:hover,
    &:focus,
    &:active {
      color: #174489;
      background: transparent;
    }
    &.active {
      color: #174489;
    }
  }
  & > button {
    text-decoration: none;
    color: ${colors.primary};
    &:hover {
      color: #174489;
    }
  }

  &.open {
    transform: translateX(10%);
  }
  ${props => {
    if (!props.open) {
      return css`
        display: none;
      `;
    }
  }}
`;
const MessageWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: auto;
  padding: 16px 0;
  text-align: left;
  p {
    margin-bottom: 16px;
    color: white;
  }
  h4 {
    color: white;
    text-align: left;
    width: 100%;
    margin-bottom: 16px;
  }
`;
const MessageBtnWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  button {
    &:first-child {
      padding: 16px 48px;
    }
  }
`;
const Overlay = styled.div`
  background-color: rgba(37, 179, 235, 0.6);
  position: absolute;
  left: 0;
  top: 83px;
  width: 100%;
  height: 100vh;
  z-index: -1;
`;
const desktopStyles = css`
  ${Menu} {
    & > a {
      text-decoration: none;
      color: ${colors.primary};
      padding: 0 16px;
      &:hover,
      &:focus,
      &:active {
        color: #174489;
      }
      &.active {
        text-decoration: underline;
        text-decoration-color: #174489;
        text-decoration-thickness: 6px;
        text-underline-offset: 20px;
        color: #174489;
      }
    }
    & > button {
      text-decoration: none;
      color: ${colors.primary};
      padding-left: 16px;
      &:hover {
        color: #174489;
      }
    }
  }
  ${ChatButton} {
    width: 90px;
    height: 90px;
    button {
      width: 90px;
      min-width: 90px;
      height: 90px;
    }
  }
  ${MessageWrap} {
    flex-direction: row;
    height: 83px;
    h4 {
      width: auto;
      margin: 0;
    }
    p {
      margin: 0;
      padding-left: 16px;
      flex: 1;
    }
  }
  ${TextWrap} {
    right: 9%;
    bottom: 20%;
    position: fixed;
    display: block;
    width: 220px;
  }
  ${MessageBtnWrap} {
    button {
      &:first-child {
        padding: 16px 20px;
      }
    }
  }
  ${BambuserWrap} {
    top: 75%;
    right: 5%;
  }
  ${ChatButton} {
    width: 100px;
    height: 100px;
    button {
      width: 100px;
      height: 100px;
      min-width: 100px;
    }
  }
`;
export default {
  Wrap,
  TopMenu,
  Logo,
  Nav,
  ButtonLink,
  Menu,
  FixedPos,
  Text,
  StyledBurger,
  StyledMenu,
  Overlay,
  MessageWrap,
  MessageBtnWrap,
  ChatButton,
  BambuserWrap,
  TextWrap,
  ButtonBambuser,
};
